export default function daysTrigger() {
  const daysTriggerObj = $('.js-days-trigger');
  daysTriggerObj.on('change', function () {
    const target = $(this).data('target');
    const days = parseInt($(this).find(':selected').data('days'), 10);
    if (!$(this).val()) {
      return;
    }
    if ($(target).length) {
      $(target).find('option').each(function () {
        if (parseInt($(this).val(), 10) > days) {
          $(this).prop({ hidden: true, disabled: true, selected: false });
        } else {
          $(this).prop({ hidden: false, disabled: false });
        }
      });
    }
  });

  if (daysTriggerObj.val()) {
    daysTriggerObj.trigger('change');
  }





}
